import React from 'react'
import { Link } from 'react-router-dom'
import Footer from "../../Footer";

const D387 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D387 - Advanced Java
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
        WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 3.27 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
          Barely took me a few hours to finish this course. I was actually questioning myself if I missed something lol.
          </p>
          <p>
            Just follow this guide:<br/>
            <a href='https://www.reddit.com/r/WGU_CompSci/comments/17fnqu2/d387_advanced_java_walkthrough/' rel="noreferrer" target='_blank'>🔗 Reddit Guide</a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default D387
